export default { sha: '5970644a6589442790cd7c4d085b737da8b2fa31', buildNumber: 'undefined' }
